export default [
    {
        path: '/static/chat/list',
        name: 'chat-list',
        component: () => import('views/modules/chat/list'),
        meta: {
            parent: '/chat/list',
            title: '在线客服',
        },
    },
    {
        path: '/static/chat/set',
        name: 'chat-set',
        component: () => import('views/modules/chat/set'),
        meta: {
            parent: '/chat/set',
            title: '在线客服',
        },
    },
    {
        path: '/static/chat/subscribe',
        name: 'chat-subscribe',
        component: () => import('views/modules/chat/subscribe'),
        meta: {
            parent: '/chat/subscribe',
            title: '消息订阅',
        },
    },
    {
        path: '/static/chat/knowledge',
        name: 'chat-knowledge',
        component: () => import('views/modules/chat/knowledge'),
        meta: {
            parent: '/chat/knowledge',
            title: '知识库',
        },
    },
    {
        path: '/static/chat/noanswered',
        name: 'chat-noanswered',
        component: () => import('views/modules/chat/noanswered'),
        meta: {
            parent: '/chat/noanswered',
            title: '知识库',
        },
    },
    {
        path: '/chat/dataanalysis',
        name: 'chat-dataanalysis',
        component: () => import('views/modules/chat/dataanalysis'),
        meta: {
            parent: '/chat/dataanalysis',
            title: '数据分析',
        },
    },
];